import { render } from "./CustomFileUploader.vue?vue&type=template&id=8586225c"
import script from "./CustomFileUploader.vue?vue&type=script&lang=js"
export * from "./CustomFileUploader.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__